import {useCallback, useEffect, useMemo} from 'react';

import isEmpty from 'lodash.isempty';
import {getChangeRequests} from 'src/modules/change-requests/services';
import {getEventsInfo} from 'src/modules/events/services';
import {getAllChangeRequests} from 'src/openapi/apis/ChangeRequestControllerApi';
import {getAllEvents} from 'src/openapi/apis/EventControllerApi';
import {ChangeRequestStatus} from 'src/openapi/models/ChangeRequestStatus';
import {useAppDispatch, useAppSelector} from 'src/store';
import {v4 as uuidv4} from 'uuid';

import {EventCreationMode} from '../../../../constants';

export const useEventCodeData = (mode: EventCreationMode) => {
    const dispatch = useAppDispatch();
    const eventsInfo = useAppSelector(getEventsInfo);
    const changeRequests = useAppSelector(getChangeRequests);

    const eventsInfoMapped = useMemo(() => {
        return !eventsInfo ? [] : eventsInfo
            .map(event => ({
                id: uuidv4(),
                eventId: event?.id || 0,
                name: event.code,
                source: event.source,
                changeRequestId: 0,
            }))
            .sort((a, b) => a.name.localeCompare(b.name));
    }, [eventsInfo]);

    const changeRequestsMapped = useMemo(() => {
        return changeRequests.filter(changeRequest =>
            changeRequest.status !== ChangeRequestStatus.APPROVED &&
            changeRequest.status !== ChangeRequestStatus.REJECTED,
        ).map(changeRequest => ({
            id: uuidv4(),
            eventId: changeRequest.event?.id || 0,
            name: changeRequest.event.code,
            source: changeRequest.event.source,
            changeRequestId: changeRequest?.id || 0,
            authorEmail: changeRequest.authorEmail,
            status: changeRequest.status,
        })).sort((a, b) => a.name.localeCompare(b.name));
    }, [changeRequests]);

    const getData = useCallback(() => {
        if (isEmpty(eventsInfo)) {
            dispatch(getAllEvents());
        }

        if (isEmpty(changeRequests)) {
            dispatch(getAllChangeRequests());
        }
    }, [changeRequests, dispatch, eventsInfo]);

    useEffect(() => {
        getData();
    }, [getData, mode]);

    return {eventsInfo, eventsInfoMapped, changeRequestsMapped, getData};
};
